import React from "react";
import { Checkbox } from "rhombus-react";
import { LEGACY_TARGET_METHODS } from "utils/constants";

export default function LegacySelection({ currentValue, onChange }) {
	function handleChange(e) {
		onChange(e.target.value);
	}

	function checkboxProps(inputValue) {
		return {
			type: "radio",
			onChange: handleChange,
			value: inputValue,
			checked: (currentValue && inputValue === currentValue),
		};
	}

	return (
		<div className="radio-options">
			<Checkbox
				label="Click Through Rate"
				key="click-through"
				{...checkboxProps(LEGACY_TARGET_METHODS.CLICK_THROUGH)}
			/>
			<Checkbox
				label="Acquisition Rate"
				key="acquisition"
				{...checkboxProps(LEGACY_TARGET_METHODS.ACQUISITION_RATE)}
			/>
			<Checkbox
				label="Interaction Rate"
				key="interaction"
				{...checkboxProps(LEGACY_TARGET_METHODS.INTERACTION_RATE)}
			/>
			<Checkbox
				label="Percentage Video Played"
				key="percentage-played"
				{...checkboxProps(LEGACY_TARGET_METHODS.PERCENTAGE_VIDEO_PLAYED)}
			/>
			<Checkbox
				label="Sound On Rate"
				key="sound-on"
				{...checkboxProps(LEGACY_TARGET_METHODS.SOUND_ON_RATE)}
			/>
		</div>
	);
}
